import React from 'react';
import HeroSection from '../components/home/HeroSection';
import SynopsisSection from '../components/home/SynopsisSection';
import TimelineTeaser from '../components/home/TimelineTeaser';
import FamiliesTeaser from '../components/home/FamiliesTeaser';
import CtaSection from '../components/home/CtaSection';

const HomePage = () => (
  <main>
    <HeroSection />
    <SynopsisSection />
    <TimelineTeaser />
    <FamiliesTeaser />
    <CtaSection />
  </main>
);

export default HomePage;